<template>
  <v-container class="pt-0">
    <v-row>
      <v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="titleHeader()" />
      </v-col>
    </v-row>

    <v-row
      justify="center"
      style="margin-top: -55px"
      v-if="checkTotalSummaryPermission()"
    >
      <v-col cols="12" md="9" class="d-flex justify-center pt-0">
        <!-- Balance -->
        <v-card
          style="border-radius: 15px; padding: 15px; width: 90%"
          elevation="2"
          @click="goToMypoint('all', 'group')"
        >
          <div class="d-flex justify-space-between align-center">
            <div style="width: 100%">
              <div style="font-size: 12px; color: gray">
                {{ $t("totalSummaryPoint") }}
              </div>
              <div
                class="ma-0 text-start d-flex align-end mt-2"
                style="font-size: 26px; font-weight: bold; line-height: 1"
                :style="{ color: site.color }"
              >
                <div
                  v-if="
                    Array.isArray(totalGroupPoint) && totalGroupPoint.length > 0
                  "
                  class="d-flex align-center justify-center"
                  style="width: 100%; gap: 4px"
                >
                  <PointSymbol
                    :type="totalGroupPoint[0].point_type_type"
                    :symbol="totalGroupPoint[0].point_type_symbol"
                    :color="totalGroupPoint[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="25"
                  />
                  {{ totalGroupPoint[0].point | commaPoint }}
                  <div
                    class="text-truncate"
                    style="
                      color: black;
                      font-size: 16px;
                      margin-left: 4px;
                      line-height: 1;
                    "
                  >
                    {{ totalGroupPoint[0].point_type_name }}
                  </div>
                </div>
              </div>
            </div>
            <v-icon color="grey" small>mdi-chevron-right</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-container fluid>
      <div class="d-flex justify-end" v-if="checkTransferPermission()">
        <v-btn
          rounded
          small
          :color="site.color"
          dark
          @click="redirectToTransferPage()"
        >
          <v-icon>mdi-account-arrow-right-outline</v-icon>
          {{ $t("transferPoint") }}
        </v-btn>
      </div>
      <v-row class="mt-2" style="margin-bottom: 64px">
        <v-col
          cols="12"
          class="pb-0"
          v-for="(item, index) in listMember"
          :key="index"
        >
          <v-card
            class="d-flex rounded-lg pa-2"
            outlined
            :elevation="item.id == myProfile.id ? '6' : '1'"
            width="100%"
            style="border: none; height: 120px; position: relative"
            :style="{
              border: `${item.id == myProfile.id ? '1' : '0'}px solid ${
                site.color || '#03A9F4'
              } `,
            }"
          >
            <v-icon
              v-if="index == 0"
              style="
                position: absolute;
                top: 0px;
                left: 0;
                background-color: #ffffff;
                border-radius: 50%;
                padding: 1px;
              "
              color="#FFC107"
              >mdi-crown-circle</v-icon
            >

            <img
              style="
                width: auto !important;
                height: 100%;
                aspect-ratio: 1;
                border-radius: 8px;
                object-fit: cover;
              "
              :style="{
                'background-color': site.color || '#eeeeee',
              }"
              :src="item.image_url"
            />

            <div class="mx-3 my-2" style="flex: 5; min-width: 0">
              <p
                class="ma-0 text-start text-subtitle-2 black--text"
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
                {{ $t("code") }} : {{ item.code }}
              </p>

              <p
                class="ma-0 text-start text-subtitle-2 black--text"
                v-snip="{
                  lines: site.account_type === 'group_account' ? 1 : 2,
                }"
              >
                {{ item.name }} {{ item.surname }}
              </p>
              <p
                v-if="site.account_type == 'group_account'"
                class="ma-0 text-start text-subtitle-2 black--text"
                v-snip="{ lines: 1 }"
              >
                {{ item.phone }}
              </p>
              <div
                class="ma-0 text-start d-flex align-center"
                style="font-weight: bold"
                v-if="checkIndividualPointPermission(item)"
              >
                <div
                  v-if="Array.isArray(item.point) && item.point.length > 0"
                  class="d-flex align-center justify-center px-1"
                  style="
                    width: 100%;
                    gap: 4px;
                    border-radius: 30px;
                    cursor: pointer;
                  "
                  :style="{
                    backgroundColor: site.color + '1A',
                    border: `2px solid ${site.color}33`,
                  }"
                  @click.stop="openMemberPointDialog(item)"
                >
                  <PointSymbol
                    :type="item.point[0].point_type_type"
                    :symbol="item.point[0].point_type_symbol"
                    :color="item.point[0].point_type_color"
                    :is_display="true"
                    :outlined_box="false"
                    :size="20"
                  />
                  <span
                    class="text-truncate"
                    :style="{ color: `${site.color}` }"
                  >
                    {{ item.point[0].point | commaPoint }}
                    {{ item.point[0].point_type_name }}
                  </span>

                  <v-icon :color="`${site.color}`" small>
                    mdi-chevron-right
                  </v-icon>
                </div>
              </div>
            </div>

            <v-spacer></v-spacer>

            <div v-if="showBtnDelete(index)" class="d-flex align-center">
              <v-btn icon color="#F44336" @click="handleRemove(item)"
                ><v-icon>mdi-delete-outline</v-icon></v-btn
              >
            </div>
          </v-card>
        </v-col>
      </v-row>
      <div v-if="!listMember.length">
        <v-col class="d-flex justify-center mt-16">
          <v-img
            class="white--text mx-auto mt-10 empty"
            :src="require('@/assets/images/out-of-stock.png')"
            max-width="150px"
          >
          </v-img>
        </v-col>
        <p class="text-center">{{ $t("errDataNotFound") }}</p>
      </div>
    </v-container>

    <v-footer v-if="showBtnAdd()" fixed padless color="white">
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-row class="pt-4" justify="center">
              <v-col cols="11" md="3" class="py-0 pb-4">
                <v-btn
                  :dark="!(limit_member <= listMember.length)"
                  block
                  class="pa-5 rounded-lg"
                  :color="site.color"
                  @click="handleAdd"
                  :disabled="limit_member <= listMember.length"
                >
                  <v-icon class="mr-2">mdi-plus-circle-outline</v-icon>
                  {{ $t("addMember") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <v-dialog v-model="dialogPoint" persistent max-width="500">
      <v-card v-if="dataMember" class="rounded-lg">
        <v-card-title class="d-flex align-center py-4 mt-2">
          <img
            :src="dataMember.image_url"
            style="
              width: 36px;
              height: 36px;
              border-radius: 50%;
              object-fit: cover;
              margin-right: 10px;
            "
            :style="{ backgroundColor: site.color || '#eeeeee' }"
          />
          <span class="text-subtitle-1 font-weight-bold">
            {{ dataMember.name }} {{ dataMember.surname }}
          </span>
        </v-card-title>

        <v-card-text class="py-0">
          <div
            v-for="(pointItem, index) in dataMember.point"
            :key="index"
            class="mb-2"
          >
            <MyPointCard
              variant="flat"
              :item="pointItem"
              :expire-date="null"
              :chip-styles="{}"
            />
          </div>
          <div
            v-if="!dataMember.point || !dataMember.point.length"
            class="text-center py-4 grey--text"
          >
            {{ $t("errDataNotFound") }}
          </div>
        </v-card-text>

        <v-card-actions class="justify-end px-4 pb-3 pt-0">
          <v-btn text :color="site.color" @click="dialogPoint = false">
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import PointSymbol from "../../../components/point/point-symbol.vue";
import MyPointCard from "../MyPoint/components/MyPointCard.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    PointSymbol,
    MyPointCard,
  },
  data: () => ({
    listMember: [],
    limit_member: 5,
    myProfile: {},
    totalGroupPoint: [],
    dialogPoint: false,
    dataMember: null,
  }),
  async created() {
    this.getMyMember();
  },
  methods: {
    openMemberPointDialog(item) {
      if (item.id == this.myProfile.id) {
        this.goToMypoint("all", "individual");
      } else {
        this.dataMember = item;
        this.dialogPoint = true;
      }
    },
    redirectToTransferPage() {
      this.$router.push({
        name: "transfer",
      });
    },
    checkTransferPermission() {
      if (this.site.account_type != "individual") {
        let detail = this.site.account_type_detail;
        if (detail.display_point == "team") {
          return false;
        } else if (
          detail.is_can_transfer_point == true &&
          detail.transfer_point_scope != null
        ) {
          if (detail.transfer_point_scope == "any_member") {
            return true;
          } else if (
            detail.transfer_point_scope == "leader" &&
            this.customer.parent_employee_id == null
          ) {
            return true;
          } else if (
            detail.transfer_point_scope == "member" &&
            this.customer.parent_employee_id != null
          ) {
            return true;
          } else if (detail.transfer_point_scope == "member_leader") {
            return true;
          } else {
            return false;
          }
        }
        return false;
      }

      return false;
    },
    checkTotalSummaryPermission() {
      if (this.site.account_type != "individual") {
        if (this.site.account_type_detail.display_point == "individual") {
          return false;
        } else if (
          this.site.account_type_detail.display_point == "individual_leader" &&
          this.customer.parent_employee_id != null
        ) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
    checkIndividualPointPermission(item) {
      if (this.site.account_type != "individual") {
        let detail = this.site.account_type_detail;

        if (
          item.id == this.customer.id &&
          detail.display_point != "team" &&
          detail.display_point != "individual_leader"
        ) {
          return true;
        } else if (
          detail.display_point == "individual_leader" &&
          this.customer.parent_employee_id == null
        ) {
          return true;
        } else if (
          detail.display_point == "individual_member_summary" &&
          item.id == this.customer.id
        ) {
          return true;
        } else if (detail.display_point == "individual_member_all") {
          return true;
        }

        return false;
      }

      return false;
    },
    showBtnAdd() {
      let check = false;
      if (
        this.listMember.length > 0 &&
        this.listMember[0].id == this.myProfile?.id &&
        this.site.account_type_detail.is_can_create_member == true
      ) {
        check = true;
      }
      return check;
    },
    showBtnDelete(index) {
      let check = false;
      if (
        index != 0 &&
        this.listMember.length > 0 &&
        this.listMember[0].id == this.myProfile?.id &&
        this.site.account_type_detail.is_can_delete_member == true
      ) {
        check = true;
      }
      return check;
    },
    titleHeader() {
      let title = `${this.$t("myMemberPage")} (${this.listMember.length}/${
        this.limit_member
      })`;
      return title;
    },
    async getMyMember() {
      this.isAppLoading(true);
      try {
        this.limit_member = this.site?.account_type_detail?.limit_member || 1;
        this.myProfile = { ...this.customer };
        let list = [];
        const response = await Axios.get("getMyMember");

        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse?.data.data || [];
          list = [...data];
        }
        list = list.map((x) => {
          x.image_url =
            x.profile_path || require("@/assets/images/user-only.svg");
          return x;
        });
        this.listMember = [...list];
        this.totalGroupPoint = dataResponse?.data.total_point;
      } catch (err) {
        console.log("getMyMember", err);
      }
      this.isAppLoading(false);
    },
    handleAdd() {
      this.$router.push({ name: "register-member" });
    },
    handleRemove(param) {
      this.$swal
        .fire({
          icon: "warning",
          text: this.$t("confirmDeleteMember", { name: param.name }),
          showCancelButton: true,
          confirmButtonText: this.$t("confirmDefault"),
          cancelButtonText: this.$t("cancel"),
          confirmButtonColor: "#F44336",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.removeMyMember(param.id);
          }
        });
    },
    async removeMyMember(id) {
      try {
        const response = await Axios.post(`removeMyMember/${id}`);
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          this.$swal
            .fire({
              icon: "success",
              text: this.$t("removeMemberSuccess"),
              showConfirmButton: false,
              timer: 1500,
            })
            .then(() => {
              this.getMyMember();
            });
        } else {
          this.$swal.fire({
            icon: "error",
            text: this.$t("removeMemberFail"),
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (err) {
        console.log("removeMyMember", err);
        this.$swal.fire({
          icon: "error",
          text: this.$t("removeMemberFail"),
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    goToMypoint(type, mode) {
      this.$router.push({
        name: "my-point",
        query: { type: type, mode: mode },
      });
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
  filters: {
    commaPoint(value) {
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return "0";
    },
  },
};
</script>

<style scoped>
.empty {
  opacity: 1;
}
::v-deep .v-btn__content {
  display: flex;
  flex-direction: row;
}
</style>
